/* eslint-disable react/require-default-props */
import React from 'react';
import {Image, RefreshControl, ScrollView, View} from 'react-native';
import {noop} from 'lodash';

import OptaviaLogo from '/asset/image/optavia_logo.png';
import TabNavigationHeader from '/component/layout/TabNavigationHeader';
import {withSafeArea} from '/provider/SafeAreaProvider';
import {black} from '/theme/color/on.color';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './BaseScreen.style';
import {useRefresh} from './useRefresh';
interface SafeAreaInsets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

interface BaseScreenProps {
  children?: React.ReactNode;
  onNavigationIconPress: () => void;
  testID: string | null;
  refreshCachedMetrics: () => void;
  safeAreaInsets: SafeAreaInsets | null;
  accessibilityElementsHidden: boolean;
  showChatFeature?: boolean;
  style?: {};
}

export const BaseScreen: React.FC<BaseScreenProps> = ({
  children = null,
  onNavigationIconPress = noop,
  testID = null,
  refreshCachedMetrics = noop,
  safeAreaInsets = withSafeArea.safeAreaInsetsDefaultProp,
  accessibilityElementsHidden = false,
  showChatFeature = true,
  style: styleProps = {},
}: BaseScreenProps) => {
  const {refreshing, onRefreshRef} = useRefresh(refreshCachedMetrics);
  const rightIcons = showChatFeature ? ['message', 'search'] : ['search'];

  const style = [styles.base, styleProps];
  style.push({
    paddingTop: (safeAreaInsets || {}).top,
  });

  return (
    <View
      accessibilityElementsHidden={accessibilityElementsHidden}
      {...testProperties(testID)}
      style={style}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.content}
        refreshControl={
          <RefreshControl
            tintColor={black}
            refreshing={refreshing}
            onRefresh={onRefreshRef}
          />
        }>
        <TabNavigationHeader
          rightIcons={rightIcons}
          onIconPress={onNavigationIconPress}>
          {children}
          <View
            style={styles.logoContainer}
            accessible={true}
            accessibilityLabel="Optavia coach">
            <Image
              accessible={false}
              testID="Shared.sharedOptaviaLogo"
              style={styles.logo}
              source={OptaviaLogo}
            />
          </View>
        </TabNavigationHeader>
      </ScrollView>
    </View>
  );
};

export default withHOC(withSafeArea)(BaseScreen);
